export default __webpack_public_path__ + "static/media/bg4.9d2bf061.jpeg";